<template>
  <div
    ref="MainDialog"
    class="fixed inset-0 z-[100] hidden"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <!-- 背景遮罩 (Backdrop) -->
    <div
      ref="modalBackdrop"
      class="fixed inset-0 transition-opacity duration-300 ease-out opacity-0 bg-white/50 backdrop-blur-sm"
    ></div>

    <!-- Modal 本體 (Panel) -->
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div
        ref="modalPanel"
        class="flex items-center justify-center min-h-full p-4 scale-95 opacity-0 sm:p-0"
      >
        <div class="flex flex-col items-center justify-center w-40 gap-4 p-6">
          <div
            class="w-8 h-8 border-2 border-gray-200 rounded-full border-t-black animate-spin"
          ></div>
          <span class="text-xs text-black">處理中...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainLoading",
  methods: {
    OpenModal() {
      // 顯示並執行動畫
      this.$refs.MainDialog.classList.remove("hidden");
      // 小延遲讓瀏覽器抓到 display 變化，觸發 transition
      this.timer != null ? clearTimeout(this.timer) : "";
      this.timer = setTimeout(() => {
        this.$refs.modalBackdrop.classList.remove("opacity-0");
        this.$refs.modalPanel.classList.remove("scale-95", "opacity-0");
        this.$refs.modalPanel.classList.add("scale-100", "opacity-100");
      }, 10);
    },
    CloseModal() {
      this.$refs.modalBackdrop.classList.add("opacity-0");
      this.$refs.modalPanel.classList.remove("scale-100", "opacity-100");
      this.$refs.modalPanel.classList.add("scale-95", "opacity-0");
      this.timer != null ? clearTimeout(this.timer) : "";
      this.timer = setTimeout(() => {
        this.$refs.MainDialog.classList.add("hidden");
        // 執行並清空回調
        if (this.onConfirm) {
          this.onConfirm();
          this.onConfirm = null;
        }
      }, 300); // 等待動畫結束
    },
  },
  watch: {
    status(new_val, old_val) {
      if (old_val == 0 && new_val != 0) {
        // open
        this.OpenModal();
      } else if (old_val != 0 && new_val == 0) {
        // close
        this.CloseModal();
      }
    },
  },
  computed: {
    status() {
      return this.$store.state.loading;
    },
  },
};
</script>
